import { useEffect } from 'react';

const SITE_URL = 'https://mahallebi.com';

interface SeoProps {
  title: string;
  description?: string;
  /** Canonical yol, ornek: "/privacy". Ana sayfa icin "/". */
  path: string;
  noindex?: boolean;
}

function setMetaContent(selector: string, content: string) {
  const el = document.head.querySelector<HTMLMetaElement>(selector);
  if (el) el.setAttribute('content', content);
}

export default function Seo({ title, description, path, noindex }: SeoProps) {
  useEffect(() => {
    document.title = title;

    const canonicalUrl = `${SITE_URL}${path === '/' ? '/' : path}`;
    const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', canonicalUrl);

    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:url"]', canonicalUrl);
    setMetaContent('meta[name="twitter:title"]', title);

    if (description) {
      setMetaContent('meta[name="description"]', description);
      setMetaContent('meta[property="og:description"]', description);
      setMetaContent('meta[name="twitter:description"]', description);
    }

    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement('meta');
        robots.setAttribute('name', 'robots');
        document.head.appendChild(robots);
      }
      robots.setAttribute('content', 'noindex');
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, noindex]);

  return null;
}
